import {RFValue} from 'react-native-responsive-fontsize';
import Ionicons from 'react-native-vector-icons/dist/Ionicons';
import styled from 'styled-components/native';

export const Card = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  border-width: 1px;
  border-radius: 16px;
  padding: 12px;
  background-color: ${({theme}) => theme.colors.alert_blue_bg};
  border-color: ${({theme}) => theme.colors.alert_blue_border};
`;

export const IconCircle = styled.View`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
  border-radius: ${RFValue(16)}px;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background-color: ${({theme}) => theme.colors.alert_blue_border};
`;

export const CardText = styled.Text`
  flex: 1;
  font-size: 13px;
  font-family: ${({theme}) => theme.fonts.semibold};
  line-height: 18px;
  margin-right: 8px;
  color: ${({theme}) => theme.colors.alert_blue_title};
`;

export const CardIcon = styled(Ionicons)`
  color: ${({theme}) => theme.colors.alert_blue_icon};
`;
